"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalFooterButton = void 0;
var react_1 = __importDefault(require("react"));
var Button_1 = require("../Button");
var styles_1 = require("../../styles");
function ModalFooterButton(props) {
    var style = props.style, rest = __rest(props, ["style"]);
    var classes = styles_1.useStyles(createStyles).classes;
    return react_1.default.createElement(Button_1.Button, __assign({ style: [classes.button, style] }, rest));
}
exports.ModalFooterButton = ModalFooterButton;
var createStyles = function () { return ({
    button: {
        minWidth: '9rem',
    },
}); };
//# sourceMappingURL=ModalFooterButton.js.map